export default __webpack_public_path__ + "static/media/waste-cleansing-cleaners.aa5733bb.jpg";